// Süper admin › Tahsilat › Tahsilatlar / Ödenenler sekmesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.billingCases';

export const billingCasesGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Tahsilatlar nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Müşteri şirketlerin lisans, cihaz ve yazarkasa yenileme ödemelerini bu sekmeden açar, izler ve faturalarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Tahsilatlar / Ödenenler'),
    filters: t(`${G}.regions.filters`, 'Durum ve sıralama'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni Tahsilat'),
    table: t(`${G}.regions.table`, 'Tahsilat listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Tahsilatlar ve Ödenenler sekmeleri'),
      text: t(`${G}.s1.text`, '"Tahsilatlar" sekmesi henüz ödenmemiş kayıtları, "Ödenenler" sekmesi ödenmiş kayıtları gösterir. Bir kayıt ödendiğinde Tahsilatlar listesinden çıkar ve Ödenenler\'e geçer; faturalama işlemleri Ödenenler sekmesinden yapılır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Kayıt durumları: Taslak, Yayında, Ödendi, İptal.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Listeyi süzün ve sıralayın'),
      text: t(`${G}.s2.text`, 'Tahsilatlar sekmesinde "Durum" ile Açık kayıtlar, Taslak, Yayında veya İptal kayıtlarını seçin; parantezdeki sayı o durumdaki kayıt sayısıdır. "Sırala" ile Kayıt no, Müşteri, Son tarih veya Tutar\'a göre sıralayın; yanındaki ok sıra yönünü değiştirir. Ödenenler sekmesinde ayrıca Ödeme zamanı\'na göre sıralanabilir.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Yeni Tahsilat açın'),
      text: t(`${G}.s3.text`, '"Yeni Tahsilat" ile müşteri, fatura şirketi ve kalemleri seçerek kayıt açın. Kaydettiğiniz kayıt hemen yayınlanır: müşteri ekranlarında ödeme duyurusu çıkar ve bildirim e-postası gönderilir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Liste açılırken Taslak durumunda kalmış kayıtlar kendiliğinden yayınlanır; ayrı bir adım beklemez.'),
        t(`${G}.s3.tip2`, 'Kalem fiyatları Ayarlar › Ürünler\'deki liste fiyatından gelir; satırda fark yazarak artırıp azaltabilirsiniz. Tutarlar KDV dahildir.'),
        t(`${G}.s3.tip3`, 'Ödenmemiş bir satıra tıklayınca ya da kalem simgesiyle (Düzenle) kaydı düzenleyebilirsiniz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Açık kayıtlarda satır işlemleri'),
      text: t(`${G}.s4.text`, 'Zincir simgesi (Ödeme linkini kopyala) müşteriye gönderebileceğiniz ödeme linkini kopyalar. Müşteri bu linkten ödeyince kayıt kendiliğinden Ödendi olur.'),
      tips: [
        t(`${G}.s4.tip1`, 'Ödendi işaretle: ödemeyi başka yoldan aldıysanız kaydı elle Ödendi yapar. Duyuru kapanır, müşteriye teşekkür e-postası gider ve lisans etkisi uygulanır: şirket demodaysa demodan çıkar, sözleşmesi 1 yıl uzar. Yazarkasa (GMÜ) yenileme kayıtları panel lisansını etkilemez.'),
        t(`${G}.s4.tip2`, 'İptal et: yayındaki kaydı iptal eder ve duyuruyu kapatır. Ödenmiş kayıt iptal edilemez.'),
        t(`${G}.s4.tip3`, 'Sil: kaydı listeden kaldırır ve açık duyuruyu kapatır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Ödenenler: faturalayın ve tekrarlayın'),
      text: t(`${G}.s5.text`, 'Fatura sütunu faturalama durumunu gösterir: Faturaya hazır, Fatura kesildi, E-fatura gönderildi, Gönderildi veya Hata. Hata rozetinin üzerine gelince hata nedeni görünür.'),
      tips: [
        t(`${G}.s5.tip1`, 'Fatura simgesi (Fatura önizle ve kes): Faturaya hazır veya Hata durumundaki kayıtta kağıt fatura önizlemesini açar; oradan "Faturaya aktar" ile fatura kesilir.'),
        t(`${G}.s5.tip2`, 'Fatura şirketinin faturalarına git: fatura kesilmiş kayıtta fatura şirketinin satış faturalarını açar. Oturum o şirketin yöneticisine geçer; süper admin paneline sağ alttaki dönüş düğmesinden dönersiniz.'),
        t(`${G}.s5.tip3`, 'Aynı kalemlerle tekrarla: ödenmiş kaydın kalemleriyle yeni bir tahsilat açar ve hemen yayınlar. Aynı kaynak için açık bir tahsilat varsa yenisi açılmaz.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Sayfalar arasında gezinin'),
      text: t(`${G}.s6.text`, 'Liste uzunsa alttaki sayfalamayı kullanın; sayfada 25, 50 veya 100 satır gösterebilirsiniz. Sağ üstteki mavi kutu listedeki kayıt sayısını gösterir.'),
    },
  ],
});
